import { ITEM_KINDS } from '@updater-core/constants/items';
import { MoveItemsState } from './types.d';
import { mergeItemsAndDeclines } from './utils';

// export function itemHasStatus(
//   state: MoveItemsState,
//   kind: ITEM_KINDS,
//   status: ITEM_STATUSES
// ) {
//   return state.items.find((item) => item.kind === kind)?.status === status;
// }

export function status(state: MoveItemsState, kind: ITEM_KINDS) {
  return state.items.find((item) => item.kind === kind)?.status;
}

export function itemMetadata(state: MoveItemsState, kind: ITEM_KINDS) {
  return state.items.find((item) => item.kind === kind)?.metadata;
}

export function mergedItems(state: MoveItemsState) {
  const { items, declinedItems } = state;
  return mergeItemsAndDeclines(items, declinedItems);
}
